const context = 'content';

export type ICID = {
  context?: string;
  path?: string;
  structureNumber?: number | string;
  structureType?: string;
  structureTitle?: string;
  deckId?: string;
  listId?: string;
  entityNumber?: number | string;
  teaserType?: string;
  presentationTitle?: string;
  event?: string;
  label?: string;
};

export type Tracking = {
  icid: ICID;
};

const strTemplate =
  ':context|:path|:structureNumber|:structureType|:structureTitle|:entityNumber|:teaserType|:presentationTitle';

const prefixAndFormats: Record<string, (data: any) => string> = {
  path: (path: any) => refinePath(path),
  structureNumber: (no: any) => {
    if (no !== undefined && no !== 'undefined') {
      if (typeof no === 'string' && no.includes('structure')) {
        return no;
      }
    }
    return no === undefined || no === 'undefined' ? 'undefined' : `structure${no}`;
  },
  entityNumber: (no: any) => {
    if (no !== undefined && no !== 'undefined') {
      if (typeof no === 'string' && no.includes('entity')) {
        return no;
      }
    }
    return no === undefined || no === 'undefined' ? 'undefined' : `entity${no}`;
  },
};

const objectMap = (obj: Record<string, any>, fn: Function) =>
  Object.fromEntries(Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)]));

export function refinePath(path = '') {
  if (!path.startsWith('/c/')) return path.replace('/forside', '/');
  return path.replace('/c/', '/focuspage/').replace(/\+/g, ' ');
}

export function format(tracking?: Tracking, omit?: string[]) {
  if (!tracking) return {};
  return {
    icid: getICIDStr(tracking.icid, omit),
    ...getICIDAtomized(tracking.icid),
  };
}

export function omitKeys(omit: string[], str: string) {
  return omit.reduce((acc, current) => acc.replace(`:${current}`, ''), str);
}

export function getICIDStr(partialICID: ICID, omit: string[] = []) {
  const icid = { context, ...partialICID };
  return Object.keys(icid).reduce(
    (acc: string, key: string) => {
      const value = (icid as any)[key];
      const formatted = (prefixAndFormats as any)[key]
        ? (prefixAndFormats as any)[key](value)
        : value;

      return acc.replace(`:${key}`, formatted);
    },
    omitKeys(omit, strTemplate)
  );
}

export function getICIDAtomized(partialICID: ICID) {
  const fillEmptyIcidValues = (x: any) => x ?? 'undefined';
  const icid = Object.keys(prefixAndFormats).reduce(
    (acc: Record<string, any>, key) => {
      const formatFunc = prefixAndFormats[key];
      acc[key] = formatFunc(acc[key]);
      return acc;
    },
    { context, event: 1, ...objectMap(partialICID, fillEmptyIcidValues) }
  );
  return {
    internalCampaign: [{ ...icid }],
  };
}
